// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'locaSkin_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '72feea6b-b4ad-4d72-bcae-3e0fdbf292ae',
      type: 'Sprite',
      name: 'YellowFlash',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 130,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 7.8,
        y: 12.8
      },
      angle: 0,
      alpha: 0.2,
      visible: true,
      tint: 16771938,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Square_White',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 2',
          height: 'height * 2'
        }
      }
    },
    {
      id: '1abf7519-5251-43be-b436-9a7c2d8c3975',
      type: 'Sprite',
      name: 'Glow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.8,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd427d829-0b0b-48ba-82b6-4b2428f3a881',
      type: 'Container',
      name: 'enFr',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        it_IT: {
          visible: false
        },
        de_DE: {
          visible: false
        },
        es_ES: {
          visible: false
        },
        pt_PT: {
          visible: false
        },
        pl_PL: {
          visible: false
        },
        nl_NL: {
          visible: false
        },
        ko_KR: {
          visible: false
        },
        ja_JP: {
          visible: false
        }
      },
      interactiveChildren: false
    },
    {
      id: '99abe11e-57bc-4b11-9e3a-be66866370d2',
      type: 'Container',
      name: 'OtherTexts',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        en_US: {
          visible: false
        },
        fr_FR: {
          visible: false
        }
      }
    },
    {
      id: 'ee43894e-cd75-4e42-b2af-5f534538cea7',
      type: 'Text',
      name: 'G',
      className: '',
      x: -76,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'G',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 150,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#0e95fe',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.5,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd427d829-0b0b-48ba-82b6-4b2428f3a881'
    },
    {
      id: '0997128f-3996-4146-97cf-90873491f9e7',
      type: 'Text',
      name: 'O',
      className: '',
      x: 35,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'O',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 150,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#0e95fe',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.5,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd427d829-0b0b-48ba-82b6-4b2428f3a881'
    },
    {
      id: '4f7ec059-418c-401b-b96b-0f6529313d2d',
      type: 'Text',
      name: 'exclamation',
      className: '',
      x: 115,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '!',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 150,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#0e95fe',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.5,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd427d829-0b0b-48ba-82b6-4b2428f3a881'
    },
    {
      id: 'c0a89461-db21-47ea-b83d-d4bf924de0eb',
      type: 'Text',
      name: 'itPt',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'GO!',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 150,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#0e95fe',
        stroke: '#fff8d9',
        strokeThickness: 20,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 89.5,
        dropShadowBlur: 0,
        dropShadowColor: '#c18d6c',
        dropShadowDistance: 8,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '99abe11e-57bc-4b11-9e3a-be66866370d2'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'en_US',
    'it_IT',
    'fr_FR',
    'de_DE',
    'es_ES',
    'pt_PT',
    'pl_PL',
    'nl_NL',
    'ko_KR',
    'ja_JP'
  ],
  animations: [
    {
      id: '8c26cd38-edff-4e3e-a284-26292ceb1ee9',
      name: 'Go_Animation',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '77b30993-b9cb-462b-a7de-2a674d5d2008',
          type: 'Setter',
          name: 'GlowAlpha',
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'Glow',
          disabled: false
        },
        {
          id: '0000e059-b464-4420-abf0-aea1c3abe089',
          type: 'Setter',
          name: 'FlashAlpha',
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'YellowFlash',
          disabled: false
        },
        {
          id: '18323d10-d00e-46c8-93cb-4d22470e44fa',
          type: 'Setter',
          name: 'GScale',
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'G',
          disabled: false
        },
        {
          id: 'cae50123-3213-42c5-9a8b-049e671410ab',
          type: 'Setter',
          name: 'TextsScale',
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'OtherTexts',
          disabled: false
        },
        {
          id: 'b799152d-593b-4d1b-a638-539cca0d5119',
          type: 'Setter',
          name: 'OScale',
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'O',
          disabled: false
        },
        {
          id: 'cc9ea299-5c9b-4ee2-b282-42214c9ee3a8',
          type: 'Setter',
          name: 'exclamationScale',
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'exclamation',
          disabled: false
        },
        {
          id: 'd44bcd39-f5cc-4ec3-bf07-3835879f364c',
          type: 'Setter',
          name: 'GlowAlpha',
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 20,
          sourceName: 'Glow',
          disabled: false
        },
        {
          id: 'a82935cf-d329-4deb-897c-5ac9f1e42bfd',
          type: 'Tween',
          name: 'GScale_1',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 20,
          sourceName: 'G',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c89aada0-e63e-4a45-b187-3859c192c942',
          type: 'Tween',
          name: 'FlashAlpha_1',
          duration: 100,
          track: 8,
          target: {
            alpha: 0.2
          },
          startAt: 20,
          sourceName: 'YellowFlash',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c7f2b741-2e7b-4804-8f45-b5ddb7a8a1be',
          type: 'Tween',
          name: 'TextsScale_1',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 20,
          sourceName: 'OtherTexts',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '58615a8a-c1b0-44e1-9053-4d7bf3c0d27b',
          type: 'Tween',
          name: 'GlowScale',
          duration: 200,
          track: 6,
          target: {
            scale: {
              y: 0,
              x: 1.6
            }
          },
          startAt: 40,
          sourceName: 'Glow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '30adb75d-e140-4cd6-9222-3d1a92c058e0',
          type: 'Tween',
          name: 'OScale_1',
          duration: 150,
          track: 3,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 70,
          sourceName: 'O',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2abbebbf-3715-46c5-b4d6-b04413c7383c',
          type: 'Tween',
          name: 'Scale',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 120,
          sourceName: 'exclamation',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '00570a5f-895b-4a20-bac4-86f4f337a29b',
          type: 'Tween',
          name: 'FlashAlpha_2',
          duration: 580,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 120,
          sourceName: 'YellowFlash',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e19a300d-90ab-4ba5-a692-120a7abcdff1',
          type: 'Tween',
          name: 'GScale_4',
          duration: 100,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 170,
          sourceName: 'G',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f284ac15-15e7-4818-9960-1515973ab58b',
          type: 'Tween',
          name: 'TextsScale_2',
          duration: 100,
          track: 10,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 170,
          sourceName: 'OtherTexts',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8149dc66-5579-45dc-8100-33df44130346',
          type: 'Tween',
          name: 'OScale_2',
          duration: 100,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 220,
          sourceName: 'O',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '77438d50-fad5-4a99-9723-70b1e10061c0',
          type: 'Tween',
          name: 'Scale_1',
          duration: 100,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 270,
          sourceName: 'exclamation',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b404000d-cdb5-4b24-941a-c4ff7893fa34',
          type: 'Tween',
          name: 'TextsScale_3',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 400,
          sourceName: 'OtherTexts',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '61a8ae59-942f-493f-b899-d05952196b3a',
          type: 'Tween',
          name: 'GScale_3',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 400,
          sourceName: 'G',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ba543abc-a8d6-404b-892b-96dc39d2b20e',
          type: 'Tween',
          name: 'OScale_3',
          duration: 150,
          track: 3,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 450,
          sourceName: 'O',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3b65ca69-53c6-4a9b-b000-13c81a2d2291',
          type: 'Tween',
          name: 'Scale_2',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 500,
          sourceName: 'exclamation',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '61b80dea-efcc-4052-a2ee-2e6feca4373c',
          type: 'Tween',
          name: 'GScale_2',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 550,
          sourceName: 'G',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4efc6007-6c1a-4013-aa69-5ab13b42c1c8',
          type: 'Tween',
          name: 'TextsScale_4',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 550,
          sourceName: 'OtherTexts',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '13d620b9-8c2d-4b72-9381-cfbfe21c6742',
          type: 'Tween',
          name: 'OScale_4',
          duration: 150,
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 600,
          sourceName: 'O',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3e255bdb-17a7-44b4-b58e-ac4ff0c52820',
          type: 'Tween',
          name: 'Scale_3',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 650,
          sourceName: 'exclamation',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventGoTextLocalizations {
  static raw = raw;
  root!: Container;
  YellowFlash!: Sprite & { data: typeof raw['list'][1]['data'] };
  Glow!: Sprite;
  enFr!: Container;
  OtherTexts!: Container;
  G!: Text;
  O!: Text;
  exclamation!: Text;
  itPt!: Text;
  locaSkin_SPL!: (Container)[];
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] })[];
  StateName!: 'en_US' | 'it_IT' | 'fr_FR' | 'de_DE' | 'es_ES' | 'pt_PT' | 'pl_PL' | 'nl_NL' | 'ko_KR' | 'ja_JP';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Go_Animation {
  Layout: {
    Glow: object;
    YellowFlash: object;
    G: object;
    OtherTexts: object;
    O: object;
    exclamation: object;
  };

  BlockTypeByName: {
    GlowAlpha: object;
    FlashAlpha: object;
    GScale: object;
    TextsScale: object;
    OScale: object;
    exclamationScale: object;
    GlowAlpha: object;
    GScale_1: object;
    FlashAlpha_1: object;
    TextsScale_1: object;
    GlowScale: object;
    OScale_1: object;
    Scale: object;
    FlashAlpha_2: object;
    GScale_4: object;
    TextsScale_2: object;
    OScale_2: object;
    Scale_1: object;
    TextsScale_3: object;
    GScale_3: object;
    OScale_3: object;
    Scale_2: object;
    GScale_2: object;
    TextsScale_4: object;
    OScale_4: object;
    Scale_3: object;
  };

  flowData = raw.animations[0];
}
